module.exports = __webpack_public_path__ + "static/temu-c3fe671ac78d74570842213444075b95.png";